import axios from "axios";
import { ApiException } from "@/services/api/ApiExceptions";
import {
  IDraftDocumentRequest,
  IEditFileType,
  IObjectFileToUpload,
  IFileDownloadRequest,
  IGdocFile,
  ISelectDocument,
  IProcessFileComplete,
  IFilterFilePaged,
  IProcessFileNoEffect,
  IProcessFileFilter,
  IProcessFileMaterialization,
  IProcessFileRevertNoEffect
} from "@/store/types/file-type";
import {
  IDocumentAuthorize,
  IDocumentDispatch,
  IProcessDocumentDOE,
  ISetToPublishDocument
} from "@/store/types/document-type";
import { IParamPaged } from "@/store/types/types";

export const getListFileDraft = ({
  process_id,
  dispatch_id,
  document_join_id
}: IDraftDocumentRequest) =>
  axios({
    url: "process/file/list-draft",
    params: { process_id, dispatch_id, document_join_id },
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const editProcessList = (file: IGdocFile) =>
  axios({
    url: `/process/file/edit/${file.id}/`,
    method: "PATCH",
    data: {
      attachment_name: file.attachment_name,
      document_type: file.document_type,
      html_source: file.html_source,
      gdocs_id: file.gdocs_id
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const editDocumentTypeBatch = ({
  process_id,
  document_type_id,
  process_file_ids
}: IEditFileType) =>
  axios({
    url: `/process/file/bulk-edit-document-type/${process_id}`,
    method: "PATCH",
    data: {
      document_type_id,
      process_file_ids
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getDocumentCloneListRequest = (
  processId: string,
  documentType: number
) =>
  axios({
    url: `process/file/clone/list/${processId}/`,
    method: "GET",
    params: {
      document_type: documentType
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const documentCloneRequest = ({
  processFileId,
  data
}: ISelectDocument) =>
  axios({
    url: `process/file/clone/${processFileId}/`,
    method: "POST",
    data
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const uploadProcessFiles = (fileObject: IObjectFileToUpload) =>
  axios({
    url: "process/file",
    method: "POST",
    data: { ...fileObject, file: fileObject.s3Data }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getProcessFileDownload = ({
  fileIds,
  processId = "",
  editable,
  isDoe = false,
  useContent,
  printer_version = undefined,
  giveKnowledgeId = undefined
}: IFileDownloadRequest) =>
  axios({
    url: `process/file/download`,
    method: "POST",
    params: {
      process_id: processId,
      editable,
      is_doe: isDoe,
      use_content_disposition: useContent,
      printer_version,
      give_knowledge_id: giveKnowledgeId
    },
    data: fileIds
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getProcessFileMaterialization = ({
  process_file_id,
  give_knowledge_id
}: IProcessFileMaterialization) =>
  axios({
    url: `process/materialization/file/${process_file_id}`,
    method: "GET",
    params: {
      give_knowledge_id
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getUploadUrl = (extension: string) =>
  axios({
    url: "process/file/presignedurl",
    method: "GET",
    params: { extension }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getDocumentValidation = (hash: string) =>
  axios({
    url: `process/file/validate`,
    method: "GET",
    params: { hash }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const createDocument = (file: IProcessFileComplete) =>
  axios({
    url: "process/file/created",
    method: "POST",
    data: file
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const createDocumentDOE = (fileDOE: IProcessDocumentDOE) =>
  axios({
    url: "process/file/created-doe-model",
    method: "POST",
    data: fileDOE
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const editDocumentDOE = (
  processFileId: string,
  fileDOE: IProcessDocumentDOE
) =>
  axios({
    url: `process/file/edit-edoweb/${processFileId}/`,
    method: "PATCH",
    data: fileDOE
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getDocument = (processFileId: string) =>
  axios({
    url: `process/file/${processFileId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getDOEDocument = (processFileId: string) =>
  axios({
    url: `process/file/get-edoweb-file/${processFileId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getProcessFilesFiltered = (filters: IProcessFileFilter) =>
  axios({
    url: `process/file/attachment/${filters.processId}/`,
    method: "GET",
    params: {
      ...filters,
      files_id: JSON.stringify(filters.files_id)
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getProcessFiles = ({
  processId,
  editable,
  page = 1,
  search = "",
  paginator_count = 10,
  order_by = undefined,
  only_count = undefined,
  filters
}: IFilterFilePaged) =>
  axios({
    url: `process/file/list/${processId}/`,
    method: "GET",
    params: {
      editable,
      page,
      search,
      paginator_count,
      order_by,
      only_count,
      ...filters
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getListAttachment = ({
  processId,
  ...params
}: {
  processId: string;
  type: "archive" | "noeffect";
} & IParamPaged) =>
  axios({
    url: `process/file/list-attachment/${processId}/`,
    method: "GET",
    params
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const setProcessFileNoEffect = ({
  processFileId,
  noEffectJustification,
  noEffectMotivation
}: IProcessFileNoEffect) =>
  axios({
    url: `process/file/no-effect/${processFileId}`,
    method: "PATCH",
    data: {
      id: processFileId,
      no_effect_justification: noEffectJustification,
      no_effect_motivation: noEffectMotivation
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const setProcessFileRevertNoEffect = ({
  processFileId,
  revertNoEffectJustification,
  revertNoEffectMotivation
}: IProcessFileRevertNoEffect) =>
  axios({
    url: `process/file/no-effect/revert/${processFileId}`,
    method: "PATCH",
    data: {
      observation: revertNoEffectJustification,
      revert_no_effect_motivation: revertNoEffectMotivation
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const setProcessToPublish = ({
  toPublish,
  processId,
  processFileId,
  dispatchId,
  keepReference
}: ISetToPublishDocument) =>
  axios({
    url: `process/file/set-to-publish/${processFileId}/`,
    method: "PATCH",
    data: {
      to_publish: toPublish,
      process_id: processId,
      dispatch_id: dispatchId,
      keep_reference: keepReference
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const authorizeToPublish = ({
  authorize,
  processFileId,
  processId
}: IDocumentAuthorize) =>
  axios({
    url: `process/file/authorize-to-publish/${processFileId}/`,
    method: "PATCH",
    data: {
      authorize,
      process_id: processId
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getDispatchFiles = ({
  dispatchId,
  ...params
}: IDocumentDispatch) =>
  axios({
    url: `process/dispatch/file/list/${dispatchId}`,
    method: "GET",
    params
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getJointFiles = ({
  jointId,
  paginator_count,
  page,
  files_id,
  only_count
}: {
  jointId: string;
  only_count: boolean;
  files_id?: string;
} & IParamPaged) =>
  axios({
    url: `process/join/list/${jointId}`,
    method: "GET",
    params: { paginator_count, page, files_id, only_count }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getAllowedExtensions = () =>
  axios({
    url: `/process/file/extensions/list`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getFileSize = (processFileId: string) =>
  axios({
    url: `/process/file/size/${processFileId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getFileCanGiveKnowledge = ({
  processId,
  processFileId
}: {
  processId: string;
  processFileId: string;
}) =>
  axios({
    url: `/process/file/check-can-give-knowledge/${processId}/${processFileId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getFileValidators = (processFileId: string) =>
  axios({
    url: `/process/file/validators/${processFileId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getPageFiles = (processId: string) =>
  axios({
    url: `/process/page-files/${processId}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });
